import { render, staticRenderFns } from "./walletGiftsActionStatus.vue?vue&type=template&id=199dc341&"
import script from "./walletGiftsActionStatus.vue?vue&type=script&lang=js&"
export * from "./walletGiftsActionStatus.vue?vue&type=script&lang=js&"
import style0 from "./walletGiftsActionStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports